const UserPermission = {
    balance: 1,
    statements: 2,
    clearError: 4,
    changePackage: 8,
    linkPackage: 16,
    disconnectPackage: 32,
    addUsers: 512,
    authorizations: 1024,
    updatePayment: 2048,
    updateBusinessDetails: 4096,
    viewUserActivityLogging: 8192,
    payAccount: 16384,
    reconnectPackage: 32768,
    financialImpact: 65536
}

export const FinancialPermissions = [
    UserPermission.changePackage,
    UserPermission.disconnectPackage,
    UserPermission.linkPackage
];

export default UserPermission;